export default __webpack_public_path__ + "static/media/dfi-cover.d0089746.svg";